export const NAMESPACE = 'openai-assistant-service-frontend';
